module.exports = __webpack_public_path__ + "images/shareLink.21d091d7.svg";